export const handleResponse = async <T>(response: Response): Promise<T> => {
  if (!response.ok) {
    let result;

    try {
      result = (await response.json()) as { detail: string };
    } catch {
      result = { error: await response.text() };
    }

    throw new Error(result.detail, {
      cause: response.status,
    });
  }

  return response.json();
};

export const handleVoidResponse = async (response: Response): Promise<void> => {
  if (!response.ok) {
    let result;

    try {
      result = (await response.json()) as { detail: string };
    } catch {
      result = { error: await response.text() };
    }

    throw new Error(result.detail, {
      cause: response.status,
    });
  }
};
